module.exports = __webpack_public_path__ + "img/2025special_06.0d3ed304.jpg";